import { render, staticRenderFns } from "./CheckoutForm.vue?vue&type=template&id=b70d6172&scoped=true"
import script from "./CheckoutForm.vue?vue&type=script&lang=js"
export * from "./CheckoutForm.vue?vue&type=script&lang=js"
import style0 from "./CheckoutForm.vue?vue&type=style&index=0&id=b70d6172&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b70d6172",
  null
  
)

export default component.exports